import { graphql } from 'gql';

export const bimContractObjectsGql = graphql(`
    query bimContractObjects(
        $contractId: Long!
        $constructionTypeId: Int
        $where: BimContractObjectDataFilterInput
        $order: [BimContractObjectDataSortInput!]
    ) {
        bimContractObjects(
            contractId: $contractId
            constructionTypeId: $constructionTypeId
            where: $where
            order: $order
        ) {
            id
            contractId
            constructionType {
                id
                code
                shortName
                name
                catalogId
                fullName
                contractFileName
                createdAt
            }
            parentId
            rootObjectId
            status
            name
            hasGuaranteedVolume
            objectSeasonDistributions {
                id
                contractSeason {
                    id
                    year
                }
                seasonValue
            }
            rationale
            order
            canSetGuaranteedVolume
            parentBasedOrder
        }
    }
`);

export const bimImportContractObjectsGql = graphql(`
    mutation bimImportContractObjects($contractId: Long!, $fileContent: FileInput!) {
        bimImportContractObjects(contractId: $contractId, fileContent: $fileContent) {
            data {
                id
            }
            result
            message
            buttonText
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimCreateContractObjectGql = graphql(`
    mutation bimCreateContractObject($contractObjectInput: BimContractObjectCreateInput!) {
        bimCreateContractObject(input: $contractObjectInput) {
            data {
                canSetGuaranteedVolume
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                hasGuaranteedVolume
                id
                name
                objectSeasonDistributions {
                    contractSeason {
                        id
                        year
                    }
                    id
                    seasonValue
                }
                order
                parentBasedOrder
                parentId
                rationale
                rootObjectId
                status
            }
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateContractObjectGql = graphql(`
    mutation bimUpdateContractObject($contractObjectInput: BimContractObjectUpdateInput!) {
        bimUpdateContractObject(input: $contractObjectInput) {
            data {
                canSetGuaranteedVolume
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                hasGuaranteedVolume
                id
                name
                objectSeasonDistributions {
                    contractSeason {
                        id
                        year
                    }
                    id
                    seasonValue
                }
                order
                parentBasedOrder
                parentId
                rationale
                rootObjectId
                status
            }
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimCreateContractSubObjectGql = graphql(`
    mutation bimCreateContractSubObject($contractObjectInput: BimContractSubObjectCreateInput!) {
        bimCreateContractSubObject(input: $contractObjectInput) {
            data {
                canSetGuaranteedVolume
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                hasGuaranteedVolume
                id
                name
                objectSeasonDistributions {
                    contractSeason {
                        id
                        year
                    }
                    id
                    seasonValue
                }
                order
                parentBasedOrder
                parentId
                rationale
                rootObjectId
                status
            }
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateContractSubObjectGql = graphql(`
    mutation bimUpdateContractSubObject($contractObjectInput: BimContractSubObjectUpdateInput!) {
        bimUpdateContractSubObject(input: $contractObjectInput) {
            data {
                canSetGuaranteedVolume
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                hasGuaranteedVolume
                id
                name
                objectSeasonDistributions {
                    contractSeason {
                        id
                        year
                    }
                    id
                    seasonValue
                }
                order
                parentBasedOrder
                parentId
                rationale
                rootObjectId
                status
            }
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimIsUniqueContractObjectNameGql = graphql(`
    query bimIsUniqueContractObjectName(
        $constructionTypeId: Int!
        $contractId: Long!
        $name: String!
        $objectId: Long
    ) {
        bimIsUniqueContractObjectName(
            constructionTypeId: $constructionTypeId
            contractId: $contractId
            name: $name
            objectId: $objectId
        ) {
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimIsUniqueContractSubObjectNameGql = graphql(`
    query bimIsUniqueContractSubObjectName($contractObjectId: Long!, $contractSubObjectId: Long, $name: String!) {
        bimIsUniqueContractSubObjectName(
            contractObjectId: $contractObjectId
            contractSubObjectId: $contractSubObjectId
            name: $name
        ) {
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimDeleteContractObjectGql = graphql(`
    mutation bimDeleteContractObject($contractObjectId: Long!) {
        bimDeleteContractObject(contractObjectId: $contractObjectId) {
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimMoveContractObjectGql = graphql(`
    mutation bimMoveContractObject($contractObjectId: Long!, $insertAfterObjectId: Long, $newParentObjectId: Long) {
        bimMoveContractObject(
            contractObjectId: $contractObjectId
            insertAfterObjectId: $insertAfterObjectId
            newParentObjectId: $newParentObjectId
        ) {
            id
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);
